module.exports = "https://trybtryb-legacy.web.app/img/purple-haze.db63471f.webp";